import { httpClient } from 'api';
import {
	MentorDevelopmentAreaKey,
	MentorDevelopmentGetResponse,
	MentorDevelopmentProgressSummaryResponse,
	ToggleMentorDevelopmentAreaResponse,
	ToggleMentorDevelopmentStepResponse,
	UpdateMentorDevelopmentScoreRequest,
	UpdateMentorDevelopmentScoreResponse,
} from 'components/userPanel/mentorDevelopment/mentorDevelopment.types';

export const mentorDevelopmentApi = {
	getMentorDevelopment: (applicationId: number) =>
		httpClient.get<MentorDevelopmentGetResponse>(`mentor-development/${applicationId}`),
	getProgressSummary: (applicationId: number) =>
		httpClient.get<MentorDevelopmentProgressSummaryResponse>(`mentor-development/${applicationId}/summary`),
	// updateMentorDevelopmentAreas: (applicationId: number, payload: UpdateMentorDevelopmentAreasRequest) =>
	// 	httpClient.post<UpdateMentorDevelopmentAreasResponse>(`mentor-development/${applicationId}/areas`, payload),

	updateScore: (
		applicationId: number,
		areaKey: MentorDevelopmentAreaKey,
		payload: UpdateMentorDevelopmentScoreRequest
	) =>
		httpClient.post<UpdateMentorDevelopmentScoreResponse>(
			`mentor-development/${applicationId}/area/${areaKey}`,
			payload
		),

	toggleMentorDevelopmentArea: (
		applicationId: number,
		areaKey: MentorDevelopmentAreaKey,
		selectedForDevelopment: boolean
	) =>
		httpClient.post<ToggleMentorDevelopmentAreaResponse>(`mentor-development/${applicationId}/area/${areaKey}`, {
			selectedForDevelopment,
		}),
	toggleMentorDevelopmentStep: (applicationId: number, stepId: number, selected: boolean) =>
		httpClient.post<ToggleMentorDevelopmentStepResponse>(
			`mentor-development/${applicationId}/steps/${stepId}/${String(selected)}`
		),
};
